import React, {useEffect} from 'react';
import { Blanca } from '../assets';
import { Contacto, Experiencia, LanguageSelector, QR } from '../components';

// Paquete para traduccion i18n
import { useTranslation } from 'react-i18next';

import { FaAward } from 'react-icons/fa';
import { SiCoffeescript } from 'react-icons/si';
import { GiHotMeal } from 'react-icons/gi';

const Home = (props) => {

    useEffect(() => {
        props.funcMenu(false)
    }, [props]);

    // Hook importado de 'react-i18next'
    const { t } = useTranslation(); 

    return (
    <div className='home w-screen min-h-screen text-center lg:px-96'>
        <div className='text-white px-10 pt-12 flex flex-col gap-2'>
            <h1 className='font-semibold text-[2rem] text-center tracking-[0.025rem]'>Blanca Villagómez</h1>
            <div className='flex justify-center items-center gap-1'><FaAward className='text-third'/><h2 className='uppercase text-[0.9rem]'>{t('home_title')}</h2></div>
        </div>
        <div className='px-10 pt-8'>
            <div className='flex items-center flex-col'>
                <img src={Blanca} alt="blanca" className='w-48'/>
                <Experiencia />
            </div> 
            <h1 className='text-white text-[1.23rem] mt-3'>{t('home_description1')} <span className='font-bold'>{t('home_description2')} </span></h1>
        </div>
        <div className='flex gap-3 px-10 pt-7 justify-center'>
            <a href="/comida" className='bg-secondary opacity-80 text-white rounded-2xl flex items-center flex-col w-40 h-36 justify-center hover:duration-150 hover:bg-primary'>
                <GiHotMeal className='text-5xl'/>
                <b>{t('home_link1')} </b>
            </a>
            <a href="/desayuno" className='bg-secondary opacity-80 text-white rounded-2xl flex items-center flex-col w-40 h-36 justify-center hover:duration-150 hover:bg-primary'>
                <SiCoffeescript className='text-5xl'/>
                <b>{t('home_link2')}</b>
            </a>
        </div>
        <div className='text-white flex justify-between px-10 pt-10'>
            <QR />
            <div className='flex items-center flex-col'>
                <LanguageSelector />
                <a className='text-white font-bold mt-5' href="https://livetech.world" target='_blank' rel='noreferrer'>Powered by Live Tech</a>
            </div>
            <Contacto />
        </div>
    </div>
    )
}

export default Home